import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import ListEventTriggerRenderer from 'flow-doctor-lib/components/filters/ListEventTriggerRenderer';
import ListMembershipEventTriggerMatchResultExplanation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/ListMembershipEventTriggerMatchResultExplanation';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListMembershipEventTriggerEvalRenderer = ({
  matchResults,
  flowRevision
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    as: "div",
    children: matchResults.map(result => {
      const matchingList = flowRevision.flow.associatedLists.find(list => list.listId === result.listId);
      return /*#__PURE__*/_jsxs(UIFlex, {
        gap: 20,
        children: [/*#__PURE__*/_jsx(UIBox, {
          basis: "50%",
          children: /*#__PURE__*/_jsx(ListEventTriggerRenderer, {
            associatedList: matchingList
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          basis: "50%",
          children: /*#__PURE__*/_jsx(ListMembershipEventTriggerMatchResultExplanation, {
            matchResult: result.matchResult,
            associatedList: matchingList
          })
        })]
      }, result.listId);
    })
  });
};
export default ListMembershipEventTriggerEvalRenderer;